import DOMPurify from 'dompurify'
import React, { useState } from 'react'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import CloseSVG from '../../../assets/svg/close.svg'
import {
  useRunBasicPayroll,
  useRunBasicPayrollGroup,
  useRunBasicPayrollSelective,
} from '../../../redux/payroll/hook'
import { formValidation } from '../../../utils/functions'
import Button from '../../button'
import FormInput from '../../form-input'
import { useHistory } from 'react-router-dom'
import Modal from '../modal'
import FormTextArea from '../../form-textarea'
import moment from 'moment'
import ButtonSelect from '../../button-select'
import { useSelector } from 'react-redux'

function RunBasicPayroll({
  isOpen,
  closeModal,
  source = 'default',
  sourceData,
}) {
  const {
    register,
    handleSubmit,
    formState: { isValid },
    errors,
  } = useForm({
    mode: 'onChange',
  })
  const { company } = useSelector((state) => state.companySlice)

  const basePayrollFee = company?.fee_charges?.basic_payroll || 400
  const payslipFee = basePayrollFee + 100
  const history = useHistory()
  const { mutateAsync: runBasicPayroll, isLoading: payrollLoading } =
    useRunBasicPayroll()
  const { mutateAsync: runBasicPayrollGroup, isLoading: payrollGroupLoading } =
    useRunBasicPayrollGroup()
  const {
    mutateAsync: runBasicPayrollSelective,
    isLoading: payrollSelectiveLoading,
  } = useRunBasicPayrollSelective()
  const [option, setOption] = useState(1)

  function onBasicPayrollSuccess(ref) {
    history.push(`/payroll/basic/preview/${ref}`)
    closeModal()
  }

  const submitForm = async (data) => {
    const desc = DOMPurify.sanitize(data?.desc)
    const month = DOMPurify.sanitize(data?.month)

    let payload = {
      desc,
      month,
      payslip: option,
    }

    if (source === 'default') {
      await runBasicPayroll(payload).then((response) => {
        onBasicPayrollSuccess(response.data.ref)
      })
    } else if (source === 'group') {
      payload.group_id = sourceData
      console.log('Final payload for group:', payload)
      await runBasicPayrollGroup(payload).then((response) => {
        onBasicPayrollSuccess(response.data.ref)
      })
    } else {
      payload.employee_ids = sourceData
      await runBasicPayrollSelective(payload).then((response) => {
        onBasicPayrollSuccess(response.data.ref)
      })
    }
  }

  return (
    <Modal
      scrollable={true}
      className='!max-w-[700px] !rounded-none !min-h-screen'
      isOpen={isOpen}
      centered={true}
    >
      <div className='flex flex-col overflow-auto'>
        <form className='form pb-3' onSubmit={handleSubmit(submitForm)}>
          <div className='pl-8 pr-8 pt-4'>
            <div className='flex flex-row justify-between items-center'>
              <span className='header-3'>Make Employee Payment</span>
              <div className='cursor-pointer' onClick={() => closeModal()}>
                <img src={CloseSVG} alt='close' />
              </div>
            </div>
          </div>
          <hr className='divider' />
          <div className='flex flex-col mx-8'>
            <FormInput
              label='Select Date'
              name='month'
              type='date'
              defaultValue={moment().format('YYYY-MM-DD')}
              inputRef={register(formValidation('text', true))}
              readOnly={
                payrollLoading || payrollGroupLoading || payrollSelectiveLoading
              }
              error={errors.month}
              errorMessage={errors.month && errors.desc.month}
            />
            <FormTextArea
              label='Description'
              placeholder={'Enter payment description'}
              name='desc'
              type='text'
              inputRef={register(formValidation('text', true))}
              readOnly={
                payrollLoading || payrollGroupLoading || payrollSelectiveLoading
              }
              error={errors.desc}
              errorMessage={errors.desc && errors.desc.message}
            />
            <ButtonSelect
              title={`I want to download and send payslips to my employee. ₦${payslipFee} per employee`}
              subtitle={''}
              isActive={option === 1}
              onClick={() => setOption(1)}
            />

            <ButtonSelect
              title={`I don't want to download and send payslips to my employee. ₦${basePayrollFee} per employee`}
              subtitle={''}
              isActive={option === 0}
              onClick={() => setOption(0)}
              className='mt-8'
            />

            <div className='w-full mt-[20px]'>
              <Button
                text='CONTINUE'
                type='submit'
                disabled={!isValid}
                loading={
                  payrollLoading ||
                  payrollGroupLoading ||
                  payrollSelectiveLoading
                }
              />
            </div>
          </div>
        </form>
      </div>
    </Modal>
  )
}

export default RunBasicPayroll
